/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminOrganizationRoleGetOrganizationRolesParams,
  OrganizationRoleAdminDTO,
  OrganizationRoleListItemAdminDTOQueryResultDTO,
  UpsertAdminOrganizationRoleDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminOrganizationRoleGetTeacherRole = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationRoleAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationRole/teacher`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationRoleGetTeacherRoleQueryKey = (organizationId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationRole/teacher`] as const;
    }

    
export const getAdminOrganizationRoleGetTeacherRoleQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationRoleGetTeacherRoleQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>> = ({ signal }) => adminOrganizationRoleGetTeacherRole(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationRoleGetTeacherRoleQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>>
export type AdminOrganizationRoleGetTeacherRoleQueryError = ErrorType<unknown>


export function useAdminOrganizationRoleGetTeacherRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationRoleGetTeacherRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationRoleGetTeacherRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationRoleGetTeacherRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetTeacherRole>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationRoleGetTeacherRoleQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationRoleGetOrganizationRole = (
    organizationId: number,
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationRoleAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationRole/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationRoleGetOrganizationRoleQueryKey = (organizationId: number,
    id: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationRole/${id}`] as const;
    }

    
export const getAdminOrganizationRoleGetOrganizationRoleQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError = ErrorType<unknown>>(organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationRoleGetOrganizationRoleQueryKey(organizationId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>> = ({ signal }) => adminOrganizationRoleGetOrganizationRole(organizationId,id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationRoleGetOrganizationRoleQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>>
export type AdminOrganizationRoleGetOrganizationRoleQueryError = ErrorType<unknown>


export function useAdminOrganizationRoleGetOrganizationRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationRoleGetOrganizationRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationRoleGetOrganizationRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationRoleGetOrganizationRole<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRole>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationRoleGetOrganizationRoleQueryOptions(organizationId,id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationRoleUpdateOrganizationRole = (
    organizationId: number,
    id: number,
    upsertAdminOrganizationRoleDTO: UpsertAdminOrganizationRoleDTO,
 ) => {
      
      
      return customInstance<OrganizationRoleAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationRole/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminOrganizationRoleDTO
    },
      );
    }
  


export const getAdminOrganizationRoleUpdateOrganizationRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationRoleUpdateOrganizationRole>>, TError,{organizationId: number;id: number;data: UpsertAdminOrganizationRoleDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationRoleUpdateOrganizationRole>>, TError,{organizationId: number;id: number;data: UpsertAdminOrganizationRoleDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationRoleUpdateOrganizationRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationRoleUpdateOrganizationRole>>, {organizationId: number;id: number;data: UpsertAdminOrganizationRoleDTO}> = (props) => {
          const {organizationId,id,data} = props ?? {};

          return  adminOrganizationRoleUpdateOrganizationRole(organizationId,id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationRoleUpdateOrganizationRoleMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationRoleUpdateOrganizationRole>>>
    export type AdminOrganizationRoleUpdateOrganizationRoleMutationBody = UpsertAdminOrganizationRoleDTO
    export type AdminOrganizationRoleUpdateOrganizationRoleMutationError = ErrorType<unknown>

    export const useAdminOrganizationRoleUpdateOrganizationRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationRoleUpdateOrganizationRole>>, TError,{organizationId: number;id: number;data: UpsertAdminOrganizationRoleDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationRoleUpdateOrganizationRole>>,
        TError,
        {organizationId: number;id: number;data: UpsertAdminOrganizationRoleDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationRoleUpdateOrganizationRoleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationRoleGetOrganizationRoles = (
    organizationId: number,
    params?: AdminOrganizationRoleGetOrganizationRolesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationRoleListItemAdminDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationRole`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminOrganizationRoleGetOrganizationRolesQueryKey = (organizationId: number,
    params?: AdminOrganizationRoleGetOrganizationRolesParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationRole`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminOrganizationRoleGetOrganizationRolesQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminOrganizationRoleGetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationRoleGetOrganizationRolesQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>> = ({ signal }) => adminOrganizationRoleGetOrganizationRoles(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationRoleGetOrganizationRolesQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>>
export type AdminOrganizationRoleGetOrganizationRolesQueryError = ErrorType<unknown>


export function useAdminOrganizationRoleGetOrganizationRoles<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminOrganizationRoleGetOrganizationRolesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationRoleGetOrganizationRoles<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationRoleGetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationRoleGetOrganizationRoles<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationRoleGetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationRoleGetOrganizationRoles<TData = Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationRoleGetOrganizationRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationRoleGetOrganizationRoles>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationRoleGetOrganizationRolesQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationRoleCreateOrganizationRole = (
    organizationId: number,
    upsertAdminOrganizationRoleDTO: UpsertAdminOrganizationRoleDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationRoleAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationRole`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminOrganizationRoleDTO, signal
    },
      );
    }
  


export const getAdminOrganizationRoleCreateOrganizationRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationRoleCreateOrganizationRole>>, TError,{organizationId: number;data: UpsertAdminOrganizationRoleDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationRoleCreateOrganizationRole>>, TError,{organizationId: number;data: UpsertAdminOrganizationRoleDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationRoleCreateOrganizationRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationRoleCreateOrganizationRole>>, {organizationId: number;data: UpsertAdminOrganizationRoleDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminOrganizationRoleCreateOrganizationRole(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationRoleCreateOrganizationRoleMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationRoleCreateOrganizationRole>>>
    export type AdminOrganizationRoleCreateOrganizationRoleMutationBody = UpsertAdminOrganizationRoleDTO
    export type AdminOrganizationRoleCreateOrganizationRoleMutationError = ErrorType<unknown>

    export const useAdminOrganizationRoleCreateOrganizationRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationRoleCreateOrganizationRole>>, TError,{organizationId: number;data: UpsertAdminOrganizationRoleDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationRoleCreateOrganizationRole>>,
        TError,
        {organizationId: number;data: UpsertAdminOrganizationRoleDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationRoleCreateOrganizationRoleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    